// eslint-disable-next-line @nx/enforce-module-boundaries
import { ObjectType } from '@vendasta/auxiliary-data-components';

export const objectTypeOptions: ObjectTypeOption[] = [
  {
    labelKey: 'COMMON.ACCOUNTS',
    value: 'business',
  },
  {
    labelKey: 'COMMON.USERS',
    value: 'user',
  },
  {
    labelKey: 'COMMON.PRODUCTS',
    value: 'product',
  },
  {
    labelKey: 'COMMON.ORDERS',
    value: 'order',
  },
  {
    labelKey: 'COMMON.FULFILLMENT_PROJECTS_AND_TASKS',
    value: 'task',
  },
];

export interface ObjectTypeOption {
  value: ObjectType;
  labelKey: string;
}
